import React from "react";
import "../../assets/css/CareGiverProfile.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import {
    badge,
    comment,
    maternity,
    nurse,
    shelterCopy,
    singleProfile,
} from "../../Constant";

function CareGiverProfile() {
    return (
        <>
            <Header />
            {/* <!-- Care Giver Profile Start Here --> */}
            <section className="care_giver_profile">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="profile_sidebar mb-4">
                                <div className="care_giver">
                                    <div className="img_box">
                                        <figure>
                                            <img src={singleProfile} alt="" />
                                        </figure>
                                        <div className="loyalty_tag">
                                            <figure>
                                                <img src={badge} alt="" />
                                            </figure>
                                        </div>
                                    </div>
                                    <div className="name_rating">
                                        <h4 className="name">John Doe</h4>
                                        <h5 className="rating">
                                            <i
                                                className="fa fa-star"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            4.5
                                        </h5>
                                    </div>
                                </div>
                                <div className="contentDv">
                                    <ul className="detailed">
                                        <li>
                                            <i
                                                className="fa fa-map-marker"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            Upper West Side, New York, NY
                                        </li>
                                        <li>
                                            <i
                                                className="fa fa-usd"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            $50 Per Hour
                                        </li>
                                        <li>
                                            <i
                                                className="fa fa-clock-o"
                                                aria-hidden="true"
                                            ></i>
                                            Average Response Time: 1 Hour
                                        </li>
                                    </ul>
                                    <div className="experienced_box">
                                        <h5>
                                            3 Years of Experience in care giving{" "}
                                        </h5>
                                        <p>
                                            Lorem ipsum dolor sit amet,
                                            consectetur adipiscing elit, sed do
                                            eiusmod tempor incidid consectetur
                                        </p>
                                    </div>
                                    <div className="cancellation">
                                        <p>
                                            Cancellation Policy is{" "}
                                            <span className="colored">
                                                3 Days
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="your_services mb-4">
                                <div className="heading_wrapper">
                                    <h4>your Services</h4>
                                    <p>Let Client's Know Services you Offer</p>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="service_box">
                                            <div className="img_box">
                                                <figure>
                                                    <img
                                                        src={maternity}
                                                        alt=""
                                                    />
                                                </figure>
                                            </div>
                                            <span className="service_name">
                                                Child Care
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="service_box">
                                            <div className="img_box">
                                                <figure>
                                                    <img
                                                        src={shelterCopy}
                                                        alt=""
                                                    />
                                                </figure>
                                            </div>
                                            <span className="service_name">
                                                House Keeping
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="service_box">
                                            <div className="img_box">
                                                <figure>
                                                    <img src={nurse} alt="" />
                                                </figure>
                                            </div>
                                            <span className="service_name">
                                                Nursing Care
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="service_box">
                                            <div className="img_box">
                                                <figure>
                                                    <img
                                                        src={maternity}
                                                        alt=""
                                                    />
                                                </figure>
                                            </div>
                                            <span className="service_name">
                                                Child Care
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="your_wallet">
                                <div className="heading_wrapper">
                                    <h4>your Wallet</h4>
                                    <p>Your All payments</p>
                                </div>
                                <div className="row align-items-center">
                                    <div className="col-md-6">
                                        <p className="total_amount">
                                            Total Amount{" "}
                                        </p>
                                        <h3>$300</h3>
                                        <a href="#" className="withdraw_btn">
                                            Withdraw
                                        </a>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="payment_status">
                                            <div className="clearance">
                                                <span className="status">
                                                    Pending Clearence
                                                </span>
                                                <h5 className="payment">$50</h5>
                                            </div>
                                            <div className="line"></div>
                                            <div className="clearance">
                                                <span className="status">
                                                    Upcoming Payments
                                                </span>
                                                <h5 className="payment">$50</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="care_giver_radius mt-5">
                                <div className="heading">
                                    <h4 className="title">My Radius</h4>
                                    <p>
                                        Care giver Provide service in this area
                                    </p>
                                </div>
                                <div className="radius_map">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6650771.284398356!2d-112.1702347!3d35.517952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb9fe5f285e3d%3A0x8b5109a227086f55!2sCalifornia%2C%20USA!5e0!3m2!1sen!2s!4v1644840610457!5m2!1sen!2s"
                                        width="100%"
                                        height="200"
                                        style={{ border: "0" }}
                                        allowFullScreen=""
                                        loading="lazy"
                                    ></iframe>
                                </div>
                                <div className="update_radius">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        data-toggle="modal"
                                        data-target="#exampleModal"
                                    >
                                        Update Your Radius
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-9">
                            <div className="actions_btn">
                                <div className="button-group">
                                    <div className="online_status">
                                        <label
                                            className="switch"
                                            id="online_switch"
                                        >
                                            <input type="checkbox" />
                                            <span className="slider"></span>
                                        </label>
                                        <p>
                                            Status{" "}
                                            <span className="status offline">
                                                Offline
                                            </span>
                                        </p>
                                    </div>
                                    <div className="edit_profiel_btn">
                                        <a href="#" className="btn">
                                            <i
                                                className="fa fa-pencil"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            Edit Profile
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="care_giver_content">
                                <div className="heading_wrapper">
                                    <h4>Care Giver Profile</h4>
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur
                                        adipiscing elit, sed do.
                                    </p>
                                </div>
                                <div className="experienceDv">
                                    <h5>
                                        3 Years of Experience in care giving{" "}
                                    </h5>
                                    <p>
                                        Description provided by care giver at
                                        signup. Lorem ipsum dolor sit amet,
                                        consectetur adipiscing elit, sed do
                                        eiusmod tempor incididunt ut labore et
                                        dolore magna aliqua. Ut enim ad minim
                                        veniam incididunt ut labore et dolore
                                        magna aliqua.
                                    </p>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-md-6">
                                        <div className="ongoing_job_box">
                                            <div className="topBar">
                                                <div className="heading_wrapper">
                                                    <h4>Ongoing Jobs</h4>
                                                    <p>
                                                        Select Services you want
                                                        to provide .
                                                    </p>
                                                </div>
                                                <div className="view_btn">
                                                    <a href="#" className="btn">
                                                        View All
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="present_jobs">
                                                <div className="job_box">
                                                    <div className="job_name">
                                                        <p className="name">
                                                            Baby Sitter Required
                                                            for 2 Days...
                                                        </p>
                                                        <span className="type">
                                                            Child Care
                                                        </span>
                                                    </div>
                                                    <div className="view_detail">
                                                        <a
                                                            href="#"
                                                            className="btn"
                                                        >
                                                            View Details
                                                        </a>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="job_box">
                                                    <div className="job_name">
                                                        <p className="name">
                                                            Baby Sitter Required
                                                            for 2 Days...
                                                        </p>
                                                        <span className="type">
                                                            Child Care
                                                        </span>
                                                    </div>
                                                    <div className="view_detail">
                                                        <a
                                                            href="#"
                                                            className="btn"
                                                        >
                                                            View Details
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="job_box">
                                                    <div className="job_name">
                                                        <p className="name">
                                                            Baby Sitter Required
                                                            for 2 Days...
                                                        </p>
                                                        <span className="type">
                                                            Child Care
                                                        </span>
                                                    </div>
                                                    <div className="view_detail">
                                                        <a
                                                            href="#"
                                                            className="btn"
                                                        >
                                                            View Details
                                                        </a>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="job_box">
                                                    <div className="job_name">
                                                        <p className="name">
                                                            Baby Sitter Required
                                                            for 2 Days...
                                                        </p>
                                                        <span className="type">
                                                            Child Care
                                                        </span>
                                                    </div>
                                                    <div className="view_detail">
                                                        <a
                                                            href="#"
                                                            className="btn"
                                                        >
                                                            View Details
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="job_box">
                                                    <div className="job_name">
                                                        <p className="name">
                                                            Baby Sitter Required
                                                            for 2 Days...
                                                        </p>
                                                        <span className="type">
                                                            Child Care
                                                        </span>
                                                    </div>
                                                    <div className="view_detail">
                                                        <a
                                                            href="#"
                                                            className="btn"
                                                        >
                                                            View Details
                                                        </a>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="job_box">
                                                    <div className="job_name">
                                                        <p className="name">
                                                            Baby Sitter Required
                                                            for 2 Days...
                                                        </p>
                                                        <span className="type">
                                                            Child Care
                                                        </span>
                                                    </div>
                                                    <div className="view_detail">
                                                        <a
                                                            href="#"
                                                            className="btn"
                                                        >
                                                            View Details
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="job_box">
                                                    <div className="job_name">
                                                        <p className="name">
                                                            Baby Sitter Required
                                                            for 2 Days...
                                                        </p>
                                                        <span className="type">
                                                            Child Care
                                                        </span>
                                                    </div>
                                                    <div className="view_detail">
                                                        <a
                                                            href="#"
                                                            className="btn"
                                                        >
                                                            View Details
                                                        </a>
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="job_box">
                                                    <div className="job_name">
                                                        <p className="name">
                                                            Baby Sitter Required
                                                            for 2 Days...
                                                        </p>
                                                        <span className="type">
                                                            Child Care
                                                        </span>
                                                    </div>
                                                    <div className="view_detail">
                                                        <a
                                                            href="#"
                                                            className="btn"
                                                        >
                                                            View Details
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="your_availability">
                                            <div className="heading_wrapper">
                                                <h4>Your Availability</h4>
                                                <p>
                                                    Select Services you want to
                                                    provide .You can select
                                                    multiple service
                                                </p>
                                            </div>
                                            <table>
                                                <tr className="top_bar">
                                                    <th>Mo</th>
                                                    <th>Tu</th>
                                                    <th>We</th>
                                                    <th>Th</th>
                                                    <th>Fr</th>
                                                    <th>Sa</th>
                                                    <th>Su</th>
                                                </tr>
                                                <tr>
                                                    <td className="status unavailable">
                                                        <span></span>
                                                    </td>
                                                    <td className="status unavailable">
                                                        <span>1</span>
                                                    </td>
                                                    <td className="status unavailable">
                                                        <span>2</span>
                                                    </td>
                                                    <td className="status unavailable">
                                                        <span>3</span>
                                                    </td>
                                                    <td className="status unavailable">
                                                        <span>4</span>
                                                    </td>
                                                    <td className="status unavailable">
                                                        <span>5</span>
                                                    </td>
                                                    <td className="status unavailable">
                                                        <span>6</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="status unavailable">
                                                        <span>7</span>
                                                    </td>
                                                    <td className="status unavailable">
                                                        <span>8</span>
                                                    </td>
                                                    <td className="status unavailable">
                                                        <span>9</span>
                                                    </td>
                                                    <td className="status unavailable">
                                                        <span>10</span>
                                                    </td>
                                                    <td className="status available">
                                                        <span>11</span>
                                                    </td>
                                                    <td className="status available">
                                                        <span>12</span>
                                                    </td>
                                                    <td className="status available">
                                                        <span>13</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="status available">
                                                        <span>14</span>
                                                    </td>
                                                    <td className="status available">
                                                        <span>15</span>
                                                    </td>
                                                    <td className="status available">
                                                        <span>16</span>
                                                    </td>
                                                    <td className="status available">
                                                        <span>17</span>
                                                    </td>
                                                    <td className="status available">
                                                        <span>18</span>
                                                    </td>
                                                    <td className="status available">
                                                        <span>19</span>
                                                    </td>
                                                    <td className="status available">
                                                        <span>20</span>
                                                    </td>
                                                </tr>
                                            </table>
                                            <div className="bottom_bar">
                                                <div className="latest_update">
                                                    <p>
                                                        Last updated on{" "}
                                                        <span className="bold">
                                                            August 7 2021
                                                        </span>
                                                    </p>
                                                </div>
                                                <div className="update_calender">
                                                    <button>
                                                        Update Calender
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-9">
                                        <div className="reviews_box mt-4">
                                            <div className="heading_wrapper">
                                                <h4>Reviews & Feedback</h4>
                                                <p>
                                                    Lorem ipsum dolor sit amet,
                                                    consectetur adipiscing elit,
                                                    sed do eiusmod tempor
                                                    incidid
                                                </p>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="content_wrapper">
                                                        <h4>
                                                            <span>350</span>{" "}
                                                            Reviews and
                                                            Feedbacks
                                                        </h4>
                                                        <div className="stars">
                                                            <div className="stars_icons">
                                                                <i
                                                                    className="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                                <i
                                                                    className="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                                <i
                                                                    className="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                                <i
                                                                    className="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                                <i
                                                                    className="fa fa-star"
                                                                    aria-hidden="true"
                                                                ></i>
                                                            </div>
                                                            <span className="stars_count">
                                                                5.0
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <div className="vertical_line"></div>
                                                    <div className="rating_progress">
                                                        <div className="progress">
                                                            <div
                                                                className="progress-bar"
                                                                role="progressbar"
                                                                style={{
                                                                    width: "80%",
                                                                }}
                                                                aria-valuenow="80"
                                                                aria-valuemin="0"
                                                                aria-valuemax="100"
                                                            ></div>
                                                            <span className="value">
                                                                200
                                                            </span>
                                                        </div>
                                                        <div className="progress">
                                                            <div
                                                                className="progress-bar"
                                                                role="progressbar"
                                                                style={{
                                                                    width: "50%",
                                                                }}
                                                                aria-valuenow="50"
                                                                aria-valuemin="0"
                                                                aria-valuemax="100"
                                                            ></div>
                                                            <span className="value">
                                                                100
                                                            </span>
                                                        </div>
                                                        <div className="progress">
                                                            <div
                                                                className="progress-bar"
                                                                role="progressbar"
                                                                style={{
                                                                    width: "30%",
                                                                }}
                                                                aria-valuenow="30"
                                                                aria-valuemin="0"
                                                                aria-valuemax="100"
                                                            ></div>
                                                            <span className="value">
                                                                30
                                                            </span>
                                                        </div>
                                                        <div className="progress">
                                                            <div
                                                                className="progress-bar"
                                                                role="progressbar"
                                                                style={{
                                                                    width: "10%",
                                                                }}
                                                                aria-valuenow="8"
                                                                aria-valuemin="0"
                                                                aria-valuemax="100"
                                                            ></div>
                                                            <span className="value">
                                                                8
                                                            </span>
                                                        </div>
                                                        <div className="progress">
                                                            <div
                                                                className="progress-bar"
                                                                role="progressbar"
                                                                style={{
                                                                    width: "5%",
                                                                }}
                                                                aria-valuenow="2"
                                                                aria-valuemin="0"
                                                                aria-valuemax="100"
                                                            ></div>
                                                            <span className="value">
                                                                2
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3"></div>
                                </div>
                                <div className="client_reviews mt-5">
                                    <div className="comments_box">
                                        <div className="img_box">
                                            <figure>
                                                <img src={comment} alt="" />
                                            </figure>
                                        </div>
                                        <div className="reivew">
                                            <div className="top_bar">
                                                <div className="name_date">
                                                    <h4 className="name">
                                                        Alie Johnson{" "}
                                                    </h4>
                                                    <span className="posted_by">
                                                        Baby Sitting
                                                    </span>
                                                </div>
                                            </div>
                                            <p>
                                                Lorem ipsum dolor sit amet,
                                                consectetur adipiscing elit, sed
                                                do eiusmod tempor incididunt ut
                                                labore et dolore magna aliqua.
                                                Ut enim ad minim veniam
                                            </p>
                                        </div>
                                    </div>
                                    <div className="comments_box">
                                        <div className="img_box">
                                            <figure>
                                                <img src={comment} alt="" />
                                            </figure>
                                        </div>
                                        <div className="reivew">
                                            <div className="top_bar">
                                                <div className="name_date">
                                                    <h4 className="name">
                                                        Alie Johnson{" "}
                                                    </h4>
                                                    <span className="posted_by">
                                                        Baby Sitting
                                                    </span>
                                                </div>
                                            </div>
                                            <p>
                                                Lorem ipsum dolor sit amet,
                                                consectetur adipiscing elit, sed
                                                do eiusmod tempor incididunt ut
                                                labore et dolore magna aliqua.
                                                Ut enim ad minim veniam
                                            </p>
                                        </div>
                                    </div>
                                    <div className="comments_box">
                                        <div className="img_box">
                                            <figure>
                                                <img src={comment} alt="" />
                                            </figure>
                                        </div>
                                        <div className="reivew">
                                            <div className="top_bar">
                                                <div className="name_date">
                                                    <h4 className="name">
                                                        Alie Johnson{" "}
                                                    </h4>
                                                    <span className="posted_by">
                                                        Baby Sitting
                                                    </span>
                                                </div>
                                            </div>
                                            <p>
                                                Lorem ipsum dolor sit amet,
                                                consectetur adipiscing elit, sed
                                                do eiusmod tempor incididunt ut
                                                labore et dolore magna aliqua.
                                                Ut enim ad minim veniam
                                            </p>
                                        </div>
                                    </div>
                                    <div className="comments_box">
                                        <div className="img_box">
                                            <figure>
                                                <img src={comment} alt="" />
                                            </figure>
                                        </div>
                                        <div className="reivew">
                                            <div className="top_bar">
                                                <div className="name_date">
                                                    <h4 className="name">
                                                        Alie Johnson{" "}
                                                    </h4>
                                                    <span className="posted_by">
                                                        Baby Sitting
                                                    </span>
                                                </div>
                                            </div>
                                            <p>
                                                Lorem ipsum dolor sit amet,
                                                consectetur adipiscing elit, sed
                                                do eiusmod tempor incididunt ut
                                                labore et dolore magna aliqua.
                                                Ut enim ad minim veniam
                                            </p>
                                        </div>
                                    </div>
                                    <div className="show_more_btn">
                                        <button>Show More</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <!-- Care Giver Profile End Here --> */}

            {/* <!-- Update Radius Start Here --> */}
            <div
                className="modal fade"
                id="exampleModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="radius_box">
                                <div className="heading_wrapper">
                                    <h4>Update Radius</h4>
                                </div>
                                <div className="para">
                                    <p>
                                        We will display this radius map to
                                        client to let them know your
                                        availability{" "}
                                    </p>
                                </div>
                                <div className="form-group">
                                    <label>
                                        What is the Maximum Distance you will
                                        travel to get to the client's Home
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Add distance in miles"
                                    />
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                >
                                    Update Radius
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default CareGiverProfile;
